import { render, staticRenderFns } from "./regisMasy.vue?vue&type=template&id=f6a862d6"
import script from "./regisMasy.vue?vue&type=script&lang=js"
export * from "./regisMasy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QItemSection,QMenu,QList,QItem,QPagination,QDialog,QSelect,QFile,QCardActions,QToggle,QIcon,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QItemSection,QMenu,QList,QItem,QPagination,QDialog,QSelect,QFile,QCardActions,QToggle,QIcon})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
